import { FileUploadErrorType } from './FileUploadErrorType';

export class FileUploadErrorResponse {
  type: FileUploadErrorType;
  file: File;

  constructor(type: FileUploadErrorType, file: File) {
    this.type = type;
    this.file = file;
  }
}
